import {
    useEffect,
    useState,
} from 'react';
import { getJson } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';

export const useInplayCounterService = (sportSlug) => {
    const SERVICE_URL = buildSpectateUrl(`/sportsbook/inplayEventsCounterButton/${sportSlug}`);
    const ZERO = 0;
    const [counter, setCounter] = useState(ZERO);

    const getCounter = async () => {
        const response = await getJson(SERVICE_URL);

        if (!response.ok) {
            return;
        }

        const respData = await response.json();
        if (respData) {
            setCounter(respData);
        }
    };

    useEffect(() => {
        getCounter();
    }, []);

    return counter;
};
